import { store } from '@/store/store';
import { clients } from '@/shared/dtos/clients';
import { crm_oportunidades } from '@/shared/dtos/crm_oportunidades';
import { crm_actividades } from '@/shared/dtos/crm_actividades';
import { ventas_cabecera } from '@/shared/dtos/ventas_cabecera';
import {
    VuexModule,
    Mutation,
    getModule,
    Module,
    Action
} from 'vuex-module-decorators';
import { ssmHttpService } from '@/shared/services/http-service';
import { API } from '@/shared/api';
import { ClientsLocalService } from '@/shared/services/clients_local_service';

@Module({
    namespaced: true,
    name: 'clientsModule',
    store,
    dynamic: true
})
class clientsModule extends VuexModule {
    public clientses: clients[] = [];
    public clients: clients = new clients();
    public tengo_usuario = false;
    public cliente_actual: clients = new clients();

    // CRM state
    public carritosByClient: any[] = [];
    public notasByClient: any[] = [];
    public cartItemsByClient: any[] = [];
    public perfilesByClient: any[] = [];
    // CRM/ERP state
    public oportunidadesByClient: crm_oportunidades[] = [];
    public actividadesByClient: crm_actividades[] = [];
    public telemetriaByClient: any[] = [];
    public ventasCabeceraByClient: ventas_cabecera[] = [];

    @Action({ commit: 'onGetMiUserData' })
    public async get_mi_user() {
        return ClientsLocalService.load();
    }

    @Action({ commit: 'onGetclientses' })
    public async getclientses() {
        return await ssmHttpService.get(API.clients);
    }

    @Action({ commit: 'onGetclients' })
    public async getclients(id: any) {
        return await ssmHttpService.get(API.clients + '/' + id);
    }

    @Action
    public async guardarclients(clients: clients) {
        return await ssmHttpService.post(API.clients, clients.toJson());
    }

    @Action
    public async modificarclients(clients: clients) {
        return await ssmHttpService.put(API.clients + '/' + clients.id, clients);
    }

    @Action({ commit: 'onSetMiUserData' })
    public async set_mi_user_data(clients: clients) {
        return await ssmHttpService.put(API.clients + '/' + clients.id, clients);
    }

    @Action
    public async eliminarclients(clients: clients) {
        return await ssmHttpService.delete(API.clients + '/' + clients.id, null, false);
    }

    // CRM actions
    @Action({ commit: 'onGetCarritosByClient' })
    public async getCarritosByClient(id: number) {
        return await ssmHttpService.get(API.clients + '/' + id + '/carritos');
    }

    @Action({ commit: 'onGetCartItemsByClient' })
    public async getCartItemsByClient(id: number) {
        return await ssmHttpService.get(API.clients + '/' + id + '/items');
    }

    @Action({ commit: 'onGetNotasByClient' })
    public async getNotasByClient(id: number) {
        return await ssmHttpService.get(API.notas_cliente + '/byClient/' + id);
    }

    @Action
    public async guardarNota(nota: any) {
        return await ssmHttpService.post(API.notas_cliente, nota);
    }

    @Action
    public async eliminarNota(id: number) {
        return await ssmHttpService.delete(API.notas_cliente + '/' + id, null, false);
    }

    @Action({ commit: 'onGetPerfilesByClient' })
    public async getPerfilesByClient(clientId: number) {
        return await ssmHttpService.get(API.perfil_comportamiento_cliente + clientId + '/historial');
    }

    @Action
    public async generarPerfilCliente(clientId: number) {
        return await ssmHttpService.post(API.perfil_comportamiento_cliente + 'generar/' + clientId, {});
    }

    @Action
    public async compactarPerfilCliente(clientId: number) {
        return await ssmHttpService.post(API.perfil_comportamiento_cliente + 'compactar/' + clientId, {});
    }

    // CRM/ERP actions
    @Action({ commit: 'onGetOportunidadesByClient' })
    public async getOportunidadesByClient(clientId: number) {
        return await ssmHttpService.get(API.crm_oportunidades + 'byClient/' + clientId);
    }

    @Action
    public async guardarOportunidad(oportunidad: crm_oportunidades) {
        if (oportunidad.isNewItem()) {
            return await ssmHttpService.post(API.crm_oportunidades, oportunidad.toJson());
        }
        return await ssmHttpService.put(API.crm_oportunidades + oportunidad.id, oportunidad);
    }

    @Action
    public async eliminarOportunidad(id: number) {
        return await ssmHttpService.delete(API.crm_oportunidades + id, null, false);
    }

    @Action({ commit: 'onGetActividadesByClient' })
    public async getActividadesByClient(clientId: number) {
        return await ssmHttpService.get(API.crm_actividades + 'byClient/' + clientId);
    }

    @Action
    public async guardarActividad(actividad: crm_actividades) {
        if (actividad.isNewItem()) {
            return await ssmHttpService.post(API.crm_actividades, actividad.toJson());
        }
        return await ssmHttpService.put(API.crm_actividades + actividad.id, actividad);
    }

    @Action({ commit: 'onGetTelemetriaByClient' })
    public async getTelemetriaByClient(clientId: number) {
        return await ssmHttpService.get(API.telemetria_cliente_by_client + clientId);
    }

    @Action({ commit: 'onGetVentasCabeceraByClient' })
    public async getVentasCabeceraByClient(clientId: number) {
        return await ssmHttpService.get(API.ventas_cabecera + 'byClient/' + clientId);
    }

    @Mutation
    public onSetMiUserData(client: clients) {
        if (client) {
            this.cliente_actual = new clients(client);
        }
        try {
            ClientsLocalService.save(this.cliente_actual);
        } catch (e) {
            console.warn("set fallback failed", e);
        }
    }

    @Mutation
    public onGetMiUserData(res: clients) {
        if (res) {
            this.tengo_usuario = true;
            this.cliente_actual = new clients(res);
        } else {
            this.tengo_usuario = false;
        }
    }

    @Mutation
    public onGetclientses(res: clients[]) {
        this.clientses = res ? res.map((x) => new clients(x)) : [];
    }

    @Mutation
    public onGetclients(res: clients) {
        this.clients = new clients(res);
    }

    // CRM mutations
    @Mutation
    public onGetCarritosByClient(res: any[]) {
        this.carritosByClient = res ? res : [];
    }

    @Mutation
    public onGetCartItemsByClient(res: any[]) {
        this.cartItemsByClient = res ? res : [];
    }

    @Mutation
    public onGetNotasByClient(res: any[]) {
        this.notasByClient = res ? res : [];
    }

    @Mutation
    public onGetPerfilesByClient(res: any[]) {
        this.perfilesByClient = res ? res : [];
    }

    @Mutation
    public onGetOportunidadesByClient(res: crm_oportunidades[]) {
        this.oportunidadesByClient = res ? res.map((x) => new crm_oportunidades(x)) : [];
    }

    @Mutation
    public onGetActividadesByClient(res: crm_actividades[]) {
        this.actividadesByClient = res ? res.map((x) => new crm_actividades(x)) : [];
    }

    @Mutation
    public onGetTelemetriaByClient(res: any[]) {
        this.telemetriaByClient = res ? res : [];
    }

    @Mutation
    public onGetVentasCabeceraByClient(res: ventas_cabecera[]) {
        this.ventasCabeceraByClient = res ? res.map((x) => new ventas_cabecera(x)) : [];
    }
}

export default getModule(clientsModule);
